import { SettingsSection } from '$common/settings-section'
import { SettingsItemWithIcon } from '$common/settings-item'
import { ArrowIOSIcon } from '$common/icons/arrow-ios'
import { t } from '$i18n'
import { openActiveDevices } from '$logic/router'

export function SettingsSecurity() {
  return (
    <SettingsSection headerText={t('settings.sections.security.title')}>
      <SettingsItemWithIcon
        text={t('settings.sections.security.activeDevices')}
        Icon={ArrowIOSIcon}
        onClick={openActiveDevices}
      />
    </SettingsSection>
  )
}
